<template>
  <div id="app">
    <NavigationBar />
    <HeroSection />
    <WhoWeAre />
    <OurServices />
    <PricingSection />
    <AboutUs />
    <ContactUs />
    <PageFooter />
    <WhatsAppButton />
  </div>
</template>


<script>
import NavigationBar from './components/NavigationBar.vue';
import HeroSection from './components/HeroSection.vue';
import WhoWeAre from './components/WhoWeAre.vue';
import OurServices from './components/OurServices.vue';
import PricingSection from './components/PricingSection.vue';
import AboutUs from './components/AboutUs.vue';
import ContactUs from './components/ContactUs.vue';
import PageFooter from './components/PageFooter.vue';
import './assets/tailwind.css';
import WhatsAppButton from './components/WhatsAppButton.vue';



export default {
  name: 'App',
  components: {
    NavigationBar,
    HeroSection,
    WhoWeAre,
    OurServices,
    PricingSection,
    AboutUs,
    ContactUs,
    WhatsAppButton,
    PageFooter
  }
};
</script>

<style>
/* تخصيصات عامة */
</style>